import { useQuery } from '@tanstack/react-query';

import { fetchUsersCount } from '@/api/v4/user.api';
import { QueryKey } from '@/config/query-client';
import { PERMISSION } from '@/user/permissions/permission.type';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';

export const useUsersCount = () => {
  const { hasRequiredPermission } = useUserPermissions();

  return useQuery({
    queryKey: [QueryKey.UsersCount],
    queryFn: fetchUsersCount,
    staleTime: 1000 * 10 * 5,
    enabled: hasRequiredPermission(PERMISSION.VIEW_USER_MANAGEMENT),
  });
};
